import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';

import { Page, PageHeader } from 'components';

import SettingsForm from './components/SettingsForm';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
    minHeight: '100%',
    flex: 1,
  },
  header: {
    marginBottom: theme.spacing(2),
  },
}));

const SettingsPage = () => {
  const classes = useStyles();
  const pageProps = {};
  const { t } = useTranslation();
  pageProps.actionFab = false;

  return (
    <Page title={t('settings')} className={classes.root}>
      <PageHeader title="settings" {...pageProps} className={classes.header} titleComponent={<SettingsForm />} />
    </Page>
  );
};

export default SettingsPage;
